<div class="session-expired-dialog">
  @if (data === informationType.SESSION_EXPIRED) {
    <p>
      Your session has expired. Please refresh the page to continue.
    </p>
  }
  @if (data === informationType.KEYCLOAK_NOT_INIT) {
    <p>
      Unable to connect to keycloak. <br />
      Contact us or refresh the page later to continue.
    </p>
  }
  @if (data === informationType.API_DOWN) {
    <p>
      Unable to connect to Webcapsule. <br />
      Contact us or refresh the page later to continue.
    </p>
  }
  <app-wbce-button type="outlined" (click)="reloadPage()">
    Reload
  </app-wbce-button>
</div>
